import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import { ApiProvider } from './context/ApiContext.jsx';
import HomePage from './pages/HomePage.jsx';
import PaymentCheckoutPage from './pages/PaymentCheckoutPage.jsx';
import PaymentSuccessPage from './pages/PaymentSuccessPage.jsx';
import PaymentCancelPage from './pages/PaymentCancelPage.jsx';
import AdminPaymentsPage from './pages/AdminPaymentsPage.jsx';
import AdminCseMarketPage from './pages/AdminCseMarketPage.jsx';
import AdminAiAnalysisPage from './pages/AdminAiAnalysisPage.jsx';
import LoginPage from './pages/LoginPage.jsx';
import UserProfilePage from './pages/UserProfilePage.jsx';
import SecurePaymentPage from './pages/SecurePaymentPage.jsx';

function App() {
  return (
    <ApiProvider>
      <Router>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/payment" element={<PaymentCheckoutPage />} />
          <Route path="/payment-success" element={<PaymentSuccessPage />} />
          <Route path="/payment-cancel" element={<PaymentCancelPage />} />
          <Route path="/admin/payments" element={<AdminPaymentsPage />} />
          <Route path="/admin/cse-market" element={<AdminCseMarketPage />} />
          <Route path="/admin/ai-analysis" element={<AdminAiAnalysisPage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/profile" element={<UserProfilePage />} />
          <Route path="/secure-payment" element={<SecurePaymentPage />} />
        </Routes>
      </Router>
    </ApiProvider>
  );
}

export default App;